import { render, staticRenderFns } from "./Datatable2.vue?vue&type=template&id=7b958f65&scoped=true&"
import script from "./Datatable2.vue?vue&type=script&lang=js&"
export * from "./Datatable2.vue?vue&type=script&lang=js&"
import style0 from "./Datatable2.vue?vue&type=style&index=0&id=7b958f65&scoped=true&lang=scss&"
import style1 from "./Datatable2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b958f65",
  null
  
)

export default component.exports